import { Entity, Field } from '@adornis/baseql/decorators.js';
import { Course } from './Course.js';

/**
 * @entity CourseIntensive
 */
@Entity()
export class CourseIntensive extends Course {
  public static override _class = 'CourseIntensive';

  @Field(() => String)
  public subjectOne?: string;

  @Field(() => String)
  public subjectTwo?: string;
}
